import script from "./CompaniesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompaniesView.vue?vue&type=script&lang=ts&setup=true"

import "./CompaniesView.vue?vue&type=style&index=0&id=2516b1e6&lang=scss"

const __exports__ = script;

export default __exports__